import React, { useCallback, useContext, useState } from 'react';
import { Control, Controller, UseFormMethods } from 'react-hook-form';
import { FormUpdater, CheckBox } from '../../../../hoc/components/inputs';
import context from '../../../../hoc/context/product/context';
import { ContactInformation } from '../contactInformation/contact-information';
import { PerformerConstants } from '../../../../hoc/constants/performer.constants';
import { PatientInformation } from '../patientInformation/patient-information';
import RichText from '../../../../hoc/components/rich-text';
import { enrollmentContext } from '../../../../hoc/context/enrollment/enrollment-context';
import { sendGaFocusEvent } from '../../patient/enrollment-ga-events';

export const CaregiverInformation: React.FC<{
	hookProps: {
		errors: UseFormMethods['errors'];
		register: UseFormMethods['register'];
	};
	control: Control;
	setValue: UseFormMethods['setValue'];
	clearErrors: UseFormMethods['clearErrors'];
}> = ({ hookProps, control, setValue, clearErrors }) => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const [isSame, setIsSame] = useState(
		enrollmentCtxt.getFormField('checkedSameAddress')?.value
	);
	const updateSameAddress = useCallback((value) => {
		enrollmentCtxt.updateFormField({
			id: 'checkedSameAddress',
			answer: value,
		});
	}, []);
	return (
		<>
			<div
				data-test="caregiver-information"
				data-testid="caregiver-information">
				<h2 className="text-2xl text-font mt-12 mb-7">
					<RichText html={ctxt.json.pages.userProfile.informationTitle} />
				</h2>
				<PatientInformation
					hookProps={hookProps}
					control={control}
					setValue={setValue}
					suffix={PerformerConstants.caregiver}
					clearErrors={clearErrors}
				/>
				<div className="flex items-center mt-10 mb-14 md:-mx-0">
					<div className="md:mt-2 mr-4">
						<Controller
							control={control}
							name="checkedSameAddress"
							render={({ onChange, value }) => (
								<CheckBox
									name={'checkedSameAddress'}
									onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
										setIsSame(!isSame);
										updateSameAddress(event);
										onChange(event);
									}}
									onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
										//TODO: Use analytics props and remove onFieldFocus
										sendGaFocusEvent(event.target.name);
									}}
									checked={value}
								/>
							)}
						/>
						<FormUpdater control={control} controlName={'checkedSameAddress'} />
					</div>
					<div className="flex flex-row">
						<div className="md:ml-6 ml-4 font-bold text-lg w-full">
							<RichText html={ctxt.json.pages.userProfile.sameAddress} />
						</div>
					</div>
				</div>
				{!isSame && (
					<ContactInformation
						hookProps={hookProps}
						control={control}
						setValue={setValue}
						suffix={PerformerConstants.caregiver}
						clearErrors={clearErrors}
					/>
				)}
			</div>
		</>
	);
};

export default CaregiverInformation;
